import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretRightbold = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 256 256",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 24,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M99.2,63.2L167.6,128L99.2,192.8"
	})
});
export default SvgCaretRightbold;
